import * as React from 'react';
import styles from './styles.pcss';
import cx from 'classnames';
import { Box, TextField } from '@mui/material';
import { SketchPicker } from 'react-color';
import { Component, createRef } from 'react';

type Props = {
  color: any;
  onChange: any;
  onChangeText: any;
  onClose: any;
  text: any;
  description: any;
  validationError: any;
};

class ChangeColorRow extends Component<Props, any> {
  pickerRef: React.RefObject<HTMLDivElement>;
  constructor(props: Props) {
    super(props);
    this.state = {
      isPickerOpen: false,
    };
    this.pickerRef = React.createRef();
  }

  handleColorChange = (newColor: { hex: any }) => {
    if (this.props.onChange) {
      this.props.onChange({ color: newColor.hex });
    }
  };

  togglePicker = () => {
    this.setState((prevState: { isPickerOpen: any }) => ({
      isPickerOpen: !prevState.isPickerOpen,
    }));
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event: MouseEvent) => {
    if (
      this.pickerRef.current &&
      !(this.pickerRef.current as any).contains(event.target)
    ) {
      this.setState({ isPickerOpen: false });
      this.props.onClose({ color: this.props.color });
    }
  };

  render() {
    const rowstyle = this.props.validationError
      ? cx(styles.colorpickerErrorRow, styles.colorpickerRow)
      : styles.colorpickerRow;
    return (
      <div className={rowstyle}>
        <div className={styles.colorpickerRowCont}>
          <div className={styles.colorpickerRowTextContainer}>
            <div className={styles.colorpickerRowText}>{this.props.text}</div>
            <div className={styles.colorpickerRowDescription}>
              {this.props.description}
            </div>
          </div>
          <Box>
            <Box
              className={styles.textFieldBox}
            >
              <TextField
                label=""
                value={this.props.color ?? ''}
                onChange={this.props.onChangeText}
                variant="outlined"
                fullWidth
                InputProps={{
                  startAdornment: (
                    <div
                      className={styles.colorPreview}
                      style={{ backgroundColor: this.props.color }}
                      onClick={this.togglePicker}
                    />
                  ),
                }}
              />
            </Box>

            {this.state.isPickerOpen && (
              <div
                ref={this.pickerRef}
                className={styles.pickerStyle}
              >
                <SketchPicker
                  color={this.props.color}
                  onChangeComplete={this.handleColorChange}
                />
              </div>
            )}
          </Box>
        </div>
        {this.props.validationError && (
          <div className={styles.colorpickerError}>
            {this.props.validationError}
          </div>
        )}
      </div>
    );
  }
}

export default ChangeColorRow;
